export const actionMenuButtonDivStyles = theme => ({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingRight: theme.spacing(2),
  position: 'relative',
  top: 12,
});

export const actionWrapperStyles = theme => ({
  height: theme.spacing(2),
  position: 'relative',
  width: '100%',
});

export const cardStyles = theme => ({
  boxShadow: theme.shadows[5],
  marginBottom: theme.spacing(2),
  overflow: 'inherit',
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    maxWidth: 950,
  },
  [theme.breakpoints.down('415')]: {
    maxWidth: 380,
  },
  [theme.breakpoints.down('400')]: {
    maxWidth: 344,
  },
});

export const chainIconStyles = theme => ({
  color: 'rgba(1, 11, 26, 0.54)',
  fontSize: 24,
  marginRight: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: 20,
    marginRight: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
  },
});

export const companyLabelStyles = theme => ({
  height: 8,
  [theme.breakpoints.down('md')]: {
    paddingBottom: theme.spacing(2),
  },
});

export const contentStyles = theme => ({
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
  marginTop: -theme.spacing(0.5),
  padding: theme.spacing(0, 2, 2),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    '&:last-child': {
      paddingBottom: 0,
    },
  },
});

export const ellipsesActiveStyles = theme => ({
  backgroundColor: theme.palette.secondary.medium,
});

export const ellipsesMenuStyles = theme => ({
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  backgroundColor: theme.palette.white,
  borderRadius: '100%',
  color: theme.palette.secondary.main,
  cursor: 'pointer',
  height: 24,
  margin: `${theme.spacing(-0.5)} ${theme.spacing(-1)} 0 0`,
  minWidth: 24,
  paddingBottom: 0,
  width: 24,
});
